var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('keep-alive',{attrs:{"exclude":['Syncfusion']}},[_c('router-view',{style:(_vm.isAppTaskRoute ? 'margin: 0 !important' : '')})],1)}
var staticRenderFns = []

export { render, staticRenderFns }